import { getters } from '/@/modules/core/app/helpers/store';
import { CurrentEstateRouteConfig } from '/@/modules/core/app/helpers/CurrentEstateRouteConfig';

export class EstateSettingsRouteConfig extends CurrentEstateRouteConfig {
  /**
   * @returns {boolean}
   */
  canAccessRoute() {
    return (
      getters.auth.getUser().permission.canAccessEstateSettings &&
      getters.auth.getCurrentEstate()?.isClearEstate
    );
  }
}
